import {zorgleuvenTheme} from '../theme/variables/zorgleuven/theme';

export const environment = {
  production: true,
  copyTokenEnabled: false,
  uiUrl: 'www.zorgathome.be',
  apiUrl: 'https://api.zorgathome.be',
  auth: {
    region: 'eu-central-1',
    userPoolId: 'eu-central-1_tEgPaVEiK',
    userPoolWebClientId: '2knsnflol9aahfe8guu6cqg421',
  },
  theme: zorgleuvenTheme,
};
